<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="elevation-1">
            <v-toolbar dark color="primary" dense>
                <v-btn icon small dark @click.native="handleModal"><v-icon small>fas fa-times-circle</v-icon></v-btn>
                <v-toolbar-title class="text-body-1">Generar reporte de asistencia</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <SingleCalendar refElement="startDate" title="Fecha inicio" :input-date.sync="startDate" />
                    </v-col>
                    <v-col cols="6">
                        <SingleCalendar refElement="endDate" title="Fecha fin" :input-date.sync="endDate" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="employeeName" label="Nombre del empleado (opcional)" clearable hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="soloSinRaya" label="Solo asistencias sin vincular a raya" color="success" hide-details></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-4" dark @click="previewPdf">
                    <v-icon left>fas fa-file-pdf</v-icon> Ver PDF
                </v-btn>
                <v-btn color="primary" @click="downloadExcel">
                    <v-icon left>fas fa-file-excel</v-icon> Generar Excel
                </v-btn>
            </v-card-actions>
        </v-card>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob" title-pdf="REPORTE DE ASISTENCIAS"
            :handlePdfModal="handlePdfModal" :dialog="showPdf" v-if="showPdf">
        </PreviewPDF>
    </v-dialog>
</template>

<script>
    import PreviewPDF from '@/components/shared/PreviewPDF.vue';
    import SingleCalendar from '@/components/shared/SingleCalendar.vue';
    import AsistenciaDataService from '@/service/empleado/asistenciaDataService';
    import { getDateLocaleNatural, getToday } from '@/utils/DateUtil';
import { extractMessage } from '@/helpers/errorHelper';

    export default {
        name: 'ExcelExportAsistencia',
        props: {
            dialog: { type: Boolean, default: false },
            handleModal: { type: Function }
        },
        components: { SingleCalendar, PreviewPDF },
        data() {
            return {
                startDate: getToday().toFormat('yyyy-MM-dd'),
                endDate: getToday().plus({ days: 1 }) .toFormat('yyyy-MM-dd'),
                employeeName: '',
                soloSinRaya: false,
                // PDF
                pdfBlob: null,
                pdfSource: null,
                showPdf: false
            }
        },
        methods: {
            buildParams() {
                return {
                    startDate: getDateLocaleNatural(this.startDate),
                    endDate: getDateLocaleNatural(this.endDate),
                    employeeName: this.employeeName,
                    soloSinRaya: this.soloSinRaya
                };
            },
            downloadExcel() {
                const { startDate, endDate, employeeName, soloSinRaya } = this.buildParams();

                AsistenciaDataService.downloadExcelByDateRange({ startDate, endDate, employeeName, soloSinRaya }).then(resp => {
                    if( resp.status == 204 ) {
                        this.$swal.fire({ icon: 'info', title: 'Reporte', text: 'No hay registros para descargar', showConfirmButton: false, timer: 1500 });
                    } else {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');

                        link.href = url;
                        link.setAttribute('download', `Lista_de_asistencias_${startDate}_${endDate}.xlsx`);

                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                }).catch(err => {
                    this.$swal.fire({ position: 'top-end', icon: 'error', text: 'Error al obtener los datos: ' + extractMessage(err), showConfirmButton: false, timer: 3500 });
                });
            },
            previewPdf() {
                const { startDate, endDate, employeeName, soloSinRaya } = this.buildParams();

                AsistenciaDataService.downloadPdfByDateRange({ startDate, endDate, employeeName, soloSinRaya }).then(response => {
                    if (response.status == 204) {
                        this.$swal.fire({ icon: 'info', title: 'Reporte PDF', text: 'No hay registros para visualizar', showConfirmButton: false, timer: 2500 });
                        return;
                    }
                    this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                    this.pdfSource = URL.createObjectURL(this.pdfBlob);
                    this.showPdf = true;
                }).catch(err => {
                    this.$swal.fire({ position: 'top-end', icon: 'error', text: 'Error al generar el reporte: ' + extractMessage(err), showConfirmButton: false, timer: 3500 });
                });
            },
            handlePdfModal() {
                this.showPdf = !this.showPdf;
                this.cleanupPdf();
            },
            cleanupPdf() {
                if (this.pdfSource) {
                    URL.revokeObjectURL(this.pdfSource);
                    this.pdfSource = null;
                }
                this.pdfBlob = null;
            }
        }
    }
</script>
